import { render } from "./TreksList.vue?vue&type=template&id=6b4ceb0e&scoped=true"
import script from "./TreksList.vue?vue&type=script&lang=js"
export * from "./TreksList.vue?vue&type=script&lang=js"

import "./TreksList.vue?vue&type=style&index=0&id=6b4ceb0e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b4ceb0e"]])

export default __exports__